// @ts-nocheck
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setBusinessInfo, setTableId } from "../../stores/business/businessSlice";
import { WelcomeBanner } from "../../components/WelcomeBanner";
import { Specialities } from "../../components/Specialities";
import { SubBanner } from "../../components/SubBanner";
import { HotelBanner } from "../../components/HotelBanner";
import { MenuSections } from "../../components/MenuSections";
import { Footer } from "../../components/Footer";
import businessConfig from "../../config/business";

const Home = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const queryParams = new URLSearchParams(location.search);
    // Table QR codes point at /home?tableid=12
    const tableId = queryParams.get("tableid");

    useEffect(() => {
        if (tableId) dispatch(setTableId(tableId));
    }, [tableId, dispatch]);

    // No ?businessid= here: the menu's business is fixed in src/config/business.js.
    useEffect(() => {
        dispatch(setBusinessInfo({ name: businessConfig.legalName, phone: businessConfig.phone }));
    }, [dispatch]);

    return (
        <div className="flex-1 bg-slate-50">
            <WelcomeBanner />

            <div className="flex-1">
                <MenuSections />
            </div>

            {/* Specialities sit after the menu: the guest scanning at the table wants
                the food first, and this reads as a closing recommendation. */}
            <Specialities />
            {/* The guest came for the food and is told about the rooms on the way out. */}
            <HotelBanner />
            {/* Contact details last: whatever the guest read on the way down, the phone
                number and the address are the things they leave the page to act on. */}
            <SubBanner />
            <Footer />
        </div>
    );
};

export default Home;
